import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import { publicCrosswalk1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicCrosswalk/img/1.avif';
import image2 from '@src/assets/images/solution/publicCrosswalk/img/2.avif';
import image3 from '@src/assets/images/solution/publicCrosswalk/img/3.avif';
import image4 from '@src/assets/images/solution/publicCrosswalk/img/4.avif';
import image5 from '@src/assets/images/solution/publicCrosswalk/img/5.avif';
import image6 from '@src/assets/images/solution/publicCrosswalk/img/6.avif';
import image7 from '@src/assets/images/solution/publicCrosswalk/img/7.avif';
import recommendation from '../common/recommendation';

export default {
  type: 'Giải pháp an toàn đô thị',

  recommend: {
    title: '',
    desc: 'ORBRO OS là nền tảng mạnh mẽ cho theo dõi vị trí thời gian thực và giám sát thông minh.<br/>Tích hợp hoàn hảo công nghệ BLE, UWB và phân tích video AI, giúp tăng cường tính an toàn, hiệu quả và khả năng mở rộng trong môi trường đô thị.',
    labels: {
      desktop: [
        { img: publicCrosswalk1, data: recommendation.ptzCamera },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.ptzCamera }, { data: recommendation.edgeAi }, { data: recommendation.switch }],
    },
  },

  banner: {
    title: 'Ngăn ngừa tai nạn tại vạch sang đường và bảo vệ người đi bộ.',
    desc: 'AI phát hiện chuyển động của xe và người đi bộ và ngay lập tức cảnh báo qua biển LED và loa khi có nguy cơ va chạm.',
  },

  numOfCard: {
    title: 'Dùng AI để loại bỏ hoàn toàn tai nạn tại vạch sang đường.',
    desc: 'Nhận diện đối tượng thời gian thực và cảnh báo hai chiều giúp chấm dứt mọi vụ tai nạn ở giao lộ có rẽ phải.',
    card: [
      {
        tag: '99.9%',
        title: 'Độ chính xác nhận diện đối tượng',
        desc: 'Phát hiện chính xác người đi bộ, xe đạp, xe tay ga và nhiều đối tượng khác.',
      },
      {
        tag: '100+',
        title: 'Số lượng đối tượng có thể nhận diện cùng lúc',
        desc: 'Theo dõi nhiều đối tượng thời gian thực.',
      },
      {
        tag: '0',
        title: 'Tai nạn tử vong kể từ khi lắp đặt',
        desc: 'Không ghi nhận trường hợp tử vong tại giao lộ có rẽ phải.',
      },
      {
        tag: '0',
        title: 'Tai nạn thương tích kể từ khi lắp đặt',
        desc: 'Không xảy ra va chạm sau khi có cảnh báo.',
      },
    ],
  },

  func: [
    {
      theme: 'Nhận diện nguy cơ va chạm giữa xe và người đi bộ một cách chính xác và cảnh báo ngay lập tức.',
      title: 'Phân tích AI xe và người đi bộ theo thời gian thực',
      desc: 'AI xác định vị trí, tốc độ và hướng di chuyển của xe và người đi bộ theo thời gian thực. Phát hiện chính xác trẻ em, xe đẩy, xe đạp, xe tay ga, kể cả tại các điểm khuất tầm nhìn.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Theo dõi thời gian thực',
      icon2: IconClockGray,
      image: image2,
    },
    {
      title: 'Xác định nguy cơ va chạm dựa trên vị trí và hướng đi tương đối',
      desc: 'Hệ thống phân tích quỹ đạo, tốc độ và hướng, chỉ cảnh báo khi đường đi giao nhau hoặc đối tượng ở gần nhau—đảm bảo cảnh báo chính xác.',
      sub2: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon2: IconTvocGray,
      image: image3,
    },
    {
      title: 'Cảnh báo hai chiều qua biển LED và hệ thống loa',
      desc: 'Biển cảnh báo tại hai bên giao lộ thông báo cho lái xe khi có người đi bộ, và thông báo cho người đi bộ khi có xe tới. Giảm đáng kể nguy cơ tai nạn.',
      sub1: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image4,
    },
    {
      theme: 'Triển khai hiệu quả & quản lý dễ dàng – bảo đảm tối ưu an toàn.',
      title: 'Edge AI với bảo mật dữ liệu độc lập',
      desc: 'Lắp đặt máy chủ tại chỗ để bảo vệ dữ liệu và ngăn rò rỉ. Hoạt động on‑premise đảm bảo quyền riêng tư và hiệu quả quản lý.',
      sub1: 'Cấu hình vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: 'Lắp đặt tại các khu vực nguy hiểm cao',
      desc: 'Cài đặt hệ thống phân tích video AI tại các giao lộ tai nạn cao hoặc khu vực trường học để quản lý an toàn hiệu quả theo đặc thù từng khu vực.',
      sub1: 'Cấu hình vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: 'Tương thích với đa hãng camera',
      desc: 'Dễ dàng tích hợp với camera của nhiều hãng, tận dụng hạ tầng có sẵn và mở rộng linh hoạt trong tương lai.',
      sub1: 'Cấu hình vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image7,
    },
  ],

  subfunc: {
    title: 'Tổng quan chức năng',
    desc: 'Bảo vệ người đi bộ nâng cao hiệu quả và giảm thiệt hại. ORBRO cung cấp đặc tính an toàn chuyên biệt cho khu vực đô thị và giao lộ nguy hiểm.',
    data: [
      {
        icon: IconSearch,
        title: 'Nhận diện nhiều đối tượng',
        desc: 'Phát hiện chính xác trẻ em, xe đẩy, xe đạp, xe tay ga và nhiều đối tượng khác cùng lúc.',
      },
      {
        icon: IconRoute,
        title: 'Theo dõi vị trí & quỹ đạo thời gian thực',
        desc: 'Giám sát vị trí, tốc độ và hướng di chuyển của từng đối tượng theo thời gian thực.',
      },
      {
        icon: IconAnalytics,
        title: 'Thuật toán đánh giá nguy cơ va chạm',
        desc: 'Tính toán khả năng va chạm dựa trên khoảng cách và quỹ đạo cắt nhau.',
      },
      {
        icon: IconChartBar,
        title: 'Cảnh báo hai chiều',
        desc: 'Biển LED cảnh báo lái xe, loa cảnh báo người đi bộ đồng thời.',
      },
      {
        icon: IconLayers,
        title: 'Bao phủ vùng khuất tầm nhìn',
        desc: 'Phát hiện người đi bộ ngay cả tại các cây che, giao lộ kín tầm nhìn.',
      },
      {
        icon: IconAnalytics,
        title: 'Ngưỡng cảnh báo chính xác',
        desc: 'Tùy chỉnh khoảng cách và tốc độ để giảm báo động sai.',
      },
      {
        icon: IconLayers,
        title: 'Bảo mật dữ liệu tại chỗ',
        desc: 'Xử lý dữ liệu tại chỗ, không gửi ra ngoài, tăng cường bảo mật.',
      },
      {
        icon: IconSearch,
        title: 'Tích hợp CCTV dễ dàng',
        desc: 'Tương thích với nhiều hãng camera hiện có, dễ dàng áp dụng.',
      },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Dòng sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
